/**
 * Company data export (#374).
 *
 * Mirrors GET /api/admin/export in go-service/internal/api/export.go: one zip
 * of CSVs, the full JSON row dump, and the sent PDFs.
 *
 * The download goes through a Blob rather than a link because `/api/admin/*`
 * requires the bearer token a plain navigation would not carry.
 */
import { apiFetchBlob } from "../../../shared/api-client";

export interface ExportOptions {
  /** Fetch the sent PDFs too. Off makes the export rows-only and much smaller. */
  documents: boolean;
  /** Include contractors' bank account numbers in contractors.csv. */
  bankDetails?: boolean;
}

export async function downloadCompanyExport(
  opts: ExportOptions,
): Promise<void> {
  const { blob, filename } = await apiFetchBlob("/api/admin/export", {
    query: {
      documents: opts.documents ? undefined : "0",
      bank_details: opts.bankDetails ? "1" : undefined,
    },
  });

  const url = URL.createObjectURL(blob);
  try {
    const a = document.createElement("a");
    a.href = url;
    a.download = filename || "hireos-export.zip";
    document.body.appendChild(a);
    a.click();
    a.remove();
  } finally {
    // Revoking immediately would race the click in some browsers; one tick is
    // enough for the download to have taken its own reference.
    setTimeout(() => URL.revokeObjectURL(url), 0);
  }
}
